// Until you are asked to change something in this file, DO NOT change it.
// The fact is that the stepper design does not match the project designs

import React from 'react';

import { Stepper as MuiStepper, Step, StepLabel, stepLabelClasses } from '@mui/material';

import type { Nullable } from '@clearverify/types';

import type { SxProp } from 'src/types/mui';
import { composeSx } from 'src/utils/styles';

import { StepIcon } from './StepIcon';
import type { StepItem } from './types';

type StepperProps = {
  steps: StepItem[];
  activeStepKey: Nullable<string>;
  containerSx?: SxProp;
};

export const Stepper: React.FC<StepperProps> = ({ steps, activeStepKey, containerSx }) => {
  const activeStepIndex = React.useMemo(() => {
    // NOTE: steps index start at 1, not 0
    return steps.findIndex(step => step.key === activeStepKey) + 1;
  }, [activeStepKey, steps]);

  return (
    <MuiStepper activeStep={activeStepIndex} sx={composeSx(stepperStyles, containerSx)}>
      {steps
        .filter(step => !step.hidden)
        .map(step => {
          return (
            <Step key={step.key}>
              <StepLabel sx={stepLabelStyles} error={step.error} slots={{ stepIcon: StepIcon }}>
                {step.label}
              </StepLabel>
            </Step>
          );
        })}
    </MuiStepper>
  );
};

const stepperStyles: SxProp = {
  width: '100%',
  alignItems: 'center',
};

const stepLabelStyles: SxProp = theme => ({
  [`.${stepLabelClasses.labelContainer}`]: {
    maxWidth: '96px',
    [`.${stepLabelClasses.label}`]: {
      color: theme.palette.text.primary,
      fontWeight: 500,
    },
    [`.${stepLabelClasses.error}`]: {
      color: theme.palette.text.primary,
    },
  },
});
